import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { SetCurrentStep, SetCurrentStepAction } from './navigation.actions';

@State<Navigation>({
  name: 'nav',
  defaults: {
    step: { step: 0, disabled: false },
    canGoBack: false,
    action: null,
  },
})
@Injectable()
export class NavigationState {
  @Action(SetCurrentStepAction)
  setCurrentStep(
    ctx: StateContext<Navigation>,
    { step }: SetCurrentStepAction
  ): void {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      step: step,
      action: { timestamp: new Date(), type: SetCurrentStep },
    });
  }
}

export interface Navigation {
  step: NavigationStep;
  action: NavigationAction | null;
  canGoBack: false;
}

export interface NavigationStep {
  step: number;
  disabled: boolean;
}

export interface NavigationAction {
  timestamp: Date;
  type: string;
}
